<template>
    <div id="itemDetail">
        <a-row>
            <a-row>
                <a-row type="flex" justify="space-between" class="paddingLeftRight"
                    style="color: #ababab;font-size: 14px;margin: 10px 0 10px 27px; font-weight: 800;">
                    <a-col>Order Detail</a-col>
                    <a-col>Total: {{step2Obj == undefined ? 0 : step2Obj.length}} records </a-col>
                </a-row>
                <a-row style="height: 80vh;overflow-y: auto">
                    <a-row v-if="step2Obj == undefined || step2Obj== null || step2Obj.length == 0"
                        style="display: flex;justify-content: center;align-items: center;height: 100%;">
                        <a-empty />
                    </a-row>
                    <a-row v-else type="flex" class="list_Liquor" v-for="(item,index) in step2Obj">
                        <!-- 左边图片 start -->
                        <a-col class="sbxs" @click="bigImgClick(item)" style="width: 138px;height: 138px;">
                            <img v-if="item.imageUrl != null && item.imageUrl != ''" :src="item.imageUrl" style=" max-height: 100%;max-width: 100%;position: absolute;width: auto;height: auto;margin: auto;top: 0;left: 0;right: 0;bottom: 0;" >
                            <img src="../../../../assets/img/noImage.png"  style=" max-height: 100%;max-width: 100%;position: absolute;width: auto;height: auto;margin: auto;top: 0;left: 0;right: 0;bottom: 0;"  v-else>
                        </a-col>
                        <!-- 左边图片 end -->
                        <a-col class="list_Liquor_detail">
                            <a-row type="flex" justify="space-between">
                                <!-- 左边 SKU 标题 START -->
                                <a-col class="list_Liquor_left">
                                    <a-col class='list_Liquor_title'>{{item.sku == '' ? '.....' : item.sku}}</a-col>
                                    <a-col style="color: #787878">{{item.skuDesc}}</a-col>
                                    <a-col style="color: #707070;font-size: 12px;top: 60px">UOM: {{item.skuUom}}</a-col>
                                </a-col>
                                <!-- 左边 SKU 标题 END -->

                                <a-col class="list_Liquor_Right">
                                    <a-col style="text-align: left;">
                                        <!-- label -->
                                        <a-col style="font-size: 13px;">Order Qty</a-col>
                                        <!-- 数据 -->
                                        <a-input-number @blur="orderQtyBlur($event,item,index)"
                                            disabled
                                            :formatter="value => `$ ${value}`.replace(/^(0+)|[^\d]/g, '')"
                                            :parser="value => value.replace(/^(0+)|[^\d]/g, '')"
                                            ref="orderQtyinputNumberRefs" :min="0" :max="item.sumAvBaseQty" size="small"
                                            v-bind:oldValue="item.sumOrderQty" style="width: 60px;"
                                            v-model="item.sumOrderQty" />
                                    </a-col>


                                    <!--:max="parseInt(item.availableQty)"-->
                                    <a-col style="margin-top: 50px;" class="sbxs">
                                        <a-popconfirm title="Are you sure delete item?" ok-text="Yes" cancel-text="No"
                                            @confirm="deleteItemDetail(item,index)">
                                            <img src="../../../../assets/img/Liqutor-delete.png" width="30" height="30">
                                        </a-popconfirm>
                                    </a-col>
                                </a-col>
                            </a-row>
                        </a-col>

                    </a-row>

                </a-row>
            </a-row>
        </a-row>


        <div style="height: 45px;"></div>
        <div :style="{
              position: 'absolute',
              right: 0,
              bottom: 0,
              width: '100%',
              borderTop: '1px solid #e9e9e9',
              padding: '10px 16px',
              background: '#fff',
              zIndex: 1,}">
            <!-- 上一步 -->
            <a-button @click='goTypeClick("Back")' class="fl" type="primary" size="small"><img
                    src="../../../../assets/img/Liqutor-left.png" width="13" height="12" class="mr4">Previous</a-button>

            <!-- 下一步 -->
            <a-button @click='goTypeClick("Next")' class="fr" type="primary" size="small"><img
                    src="../../../../assets/img/Liqutor-arrow-right.png" width="13" height="12" class="mr4">Next
            </a-button>


            <div style="text-align: center">
                <!-- 保存  离开 -->
                <a-button @click="savenonMerStep2" type="primary" size="small"><img
                        src="../../../../assets/img/Liqutor-save.png" width="13" height="12" class="mr4">Save and Exit
                </a-button>

                <!-- 重置数据 -->
                <a-popconfirm title="Are you sure reset?" ok-text="Yes" cancel-text="No" @confirm="resetStep">
                    <a-button style='margin-left: 40px;' type="danger" size="small"><img
                            src="../../../../assets/img/Liqutor-refresh.png" width="13" height="12" class="mr4">Reset
                    </a-button>
                </a-popconfirm>

            </div>

        </div>

        <a-modal :title="targetImgBig.wineName" :visible="bigImgvis" :footer="null" width="800px"
            @cancel="() => (bigImgvis = !bigImgvis)">
            <a-row type="flex" justify="start">
                <a-col style="height: 430px;overflow: auto;">
                    <a-row v-for="item in targetImgBig.pictureList">
                        <a-row class="mt4 sbxs">
                            <img v-if="item.photoBase != null" :src="item.photoBase" width="118" height="118"
                                @click="leftPhotoXiao(item)">
                            <img src="../../../../assets/img/nophoto.jpg" width="118" height="118" v-else>
                        </a-row>
                        <a-row style="width: 94px;height: 1px;background-color: #707070;margin: 12px 0"></a-row>
                    </a-row>
                </a-col>
                <a-col style="margin-left: 4px;">
                    <img v-if="rightBigImg != null" :src="rightBigImg" width="585" height="500">
                    <img src="../../../../assets/img/nophoto.jpg" width="585" height="500" v-else>
                </a-col>
            </a-row>
        </a-modal>


    </div>
</template>
<script>
    import ajax from '../../../../api/ajax'
    import api from '../../../../api/url'
    import moment from "moment";
    import sku from '../../../../api/module/sku';
    export default {
        props: {
            nonMerOrder: { // 父组件传进来的 所有这单临时数据
                type: Object,
                default: function () {
                    return {};
                }
            }
        },
        data() {
            return {
                step2Obj: [{
                        "imageUrl": "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fup.enterdesk.com%2Fedpic%2F6e%2F7e%2Fdd%2F6e7edd30f22f2b136a696d885bc2f7bd.jpg&refer=http%3A%2F%2Fup.enterdesk.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1645701504&t=8b1eef9ef72403671c01a00ee1528a92",
                        "sku": "AMQ-VM CLOTHING RAILS",
                        "skuDes": "AMQ-VM CLOTHING RAILS",
                        "skuUom": "CTN",
                        "sumOrderQty": 2,
                        "sumAvBaseQty": 11,
                        "skuOrderData": [{
                                "dudf01": "HK",
                                "dudf02": "YSL",
                                "dudf03": "123456",
                                "locationCode": "001",
                                "barcode": "SO201901120005",
                                "avBaseQty": 1,
                                "onBaseHand": 1,
                                "orderQty": 1
                            }, {
                                "dudf01": "HK",
                                "dudf02": "YSL",
                                "dudf03": "123456",
                                "locationCode": "001",
                                "barcode": "SO201901120005",
                                "avBaseQty": 1,
                                "onBaseHand": 1,
                                "orderQty": 1
                            }, {
                                "dudf01": "HK",
                                "dudf02": "YSL",
                                "dudf03": "123456",
                                "locationCode": "001",
                                "barcode": "SO201901120005",
                                "avBaseQty": 1,
                                "onBaseHand": 1,
                                "orderQty": 0
                            }, {
                                "dudf01": "HK",
                                "dudf02": "YSL",
                                "dudf03": "123456",
                                "locationCode": "001",
                                "barcode": "SO201901120005",
                                "avBaseQty": 8,
                                "onBaseHand": 8,
                                "orderQty": 0
                            },

                        ]
                    },
                    {
                        "imageUrl": "https://exp-picture.cdn.bcebos.com/b57fb6db574afa324121824454b2dc19cf2c1411.jpg?x-bce-process=image%2Fresize%2Cm_lfit%2Cw_500%2Climit_1%2Fformat%2Cf_jpg%2Fquality%2Cq_80",
                        "sku": "WOOD PLINTH 1",
                        "skuDes": "WOOD PLINTH 1",
                        "skuUom": "EA",
                        "sumOrderQty": 1,
                        "sumAvBaseQty": 20,
                        "skuOrderData": [{
                                "dudf01": "HK",
                                "dudf02": "YSL",
                                "dudf03": "123456",
                                "locationCode": "001",
                                "barcode": "SO201901120005",
                                "avBaseQty": 1,
                                "onBaseHand": 1,
                                "orderQty": 1
                            }, {
                                "dudf01": "HK",
                                "dudf02": "YSL",
                                "dudf03": "123456",
                                "locationCode": "001",
                                "barcode": "SO201901120005",
                                "avBaseQty": 1,
                                "onBaseHand": 1,
                                "orderQty": 0
                            }, {
                                "dudf01": "HK",
                                "dudf02": "YSL",
                                "dudf03": "123456",
                                "locationCode": "001",
                                "barcode": "SO201901120005",
                                "avBaseQty": 1,
                                "onBaseHand": 1,
                                "orderQty": 0
                            }, {
                                "dudf01": "HK",
                                "dudf02": "YSL",
                                "dudf03": "123456",
                                "locationCode": "001",
                                "barcode": "SO201901120005",
                                "avBaseQty": 2,
                                "onBaseHand": 2,
                                "orderQty": 0
                            },

                        ]
                    }
                ],
                bigImgvis: false,
                targetImgBig: {},
                rightBigImg: ''
            }
        },
        created() {
            console.info("购物车")
            this.step2Obj = this.nonMerOrder.nonMerOrderDetails;
        },
        methods: {
            moment,
            updateCurrentStep() {

            },
            savenonMerStep2() { // 页面Save and Exit 按钮
                this.saveAndRedirect('close');
            },

            saveAndRedirect(redirectType) {
                if (this.nonMerOrder.nonMerOrderDetails == null || this.nonMerOrder.nonMerOrderDetails.length == 0) {
                    if (redirectType == 'close') {
                        this.$emit('goClose', redirectType)
                    } else {
                        this.$emit('goType', redirectType)
                    }
                } else {
                    ajax.get(api.UDATECURRENTSTEP,{'currentStep' : '2'}).then(res => {
                        if (res.code == 200) {
                            if (redirectType == 'close') {
                                this.$message.success(res.msg);
                                this.$emit('goClose', redirectType)
                            } else {
                                this.$emit('goType', redirectType)
                            }
                        } else {
                            this.$message.warning(res.msg);
                        }
                    })
                }
            },
            resetStep() { //   页面 Reset 按钮
                console.info('删除整个购物车')
                this.deleteShopCart(null, 0);
            },
            //            放大图片
            bigImgClick(item) {
                this.targetImgBig = item
                if (item.pictureList.length > 0) {
                    this.rightBigImg = item.pictureList[0].photo
                } else {
                    this.rightBigImg = item.photoBase
                }
                this.bigImgvis = true
            },
            leftPhotoXiao(item) {
                this.rightBigImg = item.photo
            },
            //            跳转
            goTypeClick(type) {
                this.saveAndRedirect(type)
            },
            deleteItemDetail(item, index) {
                console.info('删除单条数据')
                this.deleteShopCart(item, index)
            },
            deleteShopCart(item, index) {
                let newNonMerOrderDetails = [];
                if (item != null) {
                    let invList = item.skuOrderData;
                    for (let inv of invList) {
                        let invSku = {};
                        invSku.sku = item.sku
                        invSku.skuUom = item.skuUom
                        invSku.dudf01 = inv.dudf01,
                            invSku.dudf02 = inv.dudf02,
                            invSku.dudf03 = inv.dudf03,
                            invSku.locationCode = inv.locationCode,
                            invSku.lotId = inv.lotId,
                            invSku.imageUrl = inv.imageUrl,
                            invSku.orderQty = inv.orderQty,
                            newNonMerOrderDetails.push(invSku)
                    }
                } else {
                    let list = this.step2Obj;
                    if (list.length == 0) {
                        return;
                    }

                    for (let detail of list) {
                        let invList = detail.skuOrderData;
                        for (let inv of invList) {
                            let invSku = {};
                            invSku.sku = detail.sku
                            invSku.skuUom = detail.skuUom
                            invSku.dudf01 = inv.dudf01,
                                invSku.dudf02 = inv.dudf02,
                                invSku.dudf03 = inv.dudf03,
                                invSku.locationCode = inv.locationCode,
                                invSku.lotId = inv.lotId,
                                invSku.imageUrl = inv.imageUrl,
                                invSku.orderQty = inv.orderQty,
                                newNonMerOrderDetails.push(invSku)
                        }

                    }
                }

                if (newNonMerOrderDetails != null && newNonMerOrderDetails.length > 0) {
                    let params = {
                        nonMerOrderDetails: newNonMerOrderDetails,
                        currentStep: '2'
                    }
                    ajax.post(api.INVWINERESETTEMPORDERNONMER, params).then(res => {
                        if (res.code == 200) {
                            this.$message.success(res.msg)
                            // 重新刷新购物车
                            if (item != null) {
                                for (let i in this.step2Obj) {
                                    if (this.step2Obj[i] == item) {
                                        this.step2Obj.splice(i, 1)
                                    }
                                }
                                for (let i in this.nonMerOrder.nonMerOrderDetails) {
                                    if (this.nonMerOrder.nonMerOrderDetails[i] == item) {
                                        this.nonMerOrder.nonMerOrderDetails.splice(i, 1)
                                    }
                                }
                            } else {
                                this.nonMerOrder.nonMerOrderDetails = [],
                                    this.step2Obj = []
                            }
                        } else {
                            this.$message.warning(res.msg);
                        }
                    })
                }


            }







        }
    }
</script>
<style lang="less" scoped>
    #itemDetail {
        .list_Liquor {
            border-bottom: 1px solid #b8b8b8;
            padding: 6px 4px 6px 0;

            .list_Liquor_detail {
                flex: 1;
                margin-left: 10px;
                margin-top: 8px;

                .list_Liquor_left {
                    .list_Liquor_title {
                        color: #787878;
                        font-weight: 800;
                        margin-bottom: 2px;
                        font-size: 14px;
                    }
                }

                .list_Liquor_Right {
                    color: #707070;
                    text-align: right;

                    .list_Liquor_Right_T {
                        margin-bottom: 32px;
                    }
                }
            }
        }
    }
</style>